function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,427.57c23.6,24.92,81.54,15.79,106.64,0C320.14,376.32,462.92,291,469.39,167.4c2.75-52.53-43.58-80.12-62.93-88.21C360,59.75,309,53.92,258.65,51.67c-52.57-2.35-109-.52-156.31,25.13C84.4,86.51,67.48,99,55.9,116c-11.76,17.28-18.53,37.86-20.33,58.63-2.89,33.5,6.12,67.09,19.75,97.83s31.8,59.2,48.48,88.4C114.69,379.89,112.16,406.58,132,427.57Z",
    style: {
      fill: "#FAA700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,427.57c23.6,24.92,81.54,15.79,106.64,0C320.14,376.32,462.92,291,469.39,167.4c2.75-52.53-43.58-80.12-62.93-88.21C360,59.75,309,53.92,258.65,51.67c-52.57-2.35-109-.52-156.31,25.13C84.4,86.51,67.48,99,55.9,116c-11.76,17.28-18.53,37.86-20.33,58.63-2.89,33.5,6.12,67.09,19.75,97.83s31.8,59.2,48.48,88.4C114.69,379.89,112.16,406.58,132,427.57Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.13,
    y: 132.19,
    width: 56.97,
    height: 36.43,
    rx: 3.51,
    transform: "matrix(0.96, 0.29, -0.29, 0.96, 48.42, -25.9)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.18,
    y1: 132.84,
    x2: 141.69,
    y2: 149.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.52,
    y1: 138.31,
    x2: 140.04,
    y2: 154.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.45,165.06a3.56,3.56,0,0,0,.31,2.78,3.6,3.6,0,0,1-2.63.22,3.55,3.55,0,1,1,4.12-5.14A3.6,3.6,0,0,0,123.45,165.06Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.24,167.12a3.55,3.55,0,1,1-2.36-4.43A3.55,3.55,0,0,1,130.24,167.12Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.6,
    y: 202.08,
    width: 48.45,
    height: 30.98,
    rx: 3.51,
    transform: "translate(82.13 -119.07) rotate(16.86)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.04,
    y1: 202.62,
    x2: 468.41,
    y2: 216.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420.63,
    y1: 207.28,
    x2: 466.99,
    y2: 221.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.89,230a3,3,0,0,0,.26,2.36,3,3,0,1,1-.48-5.58,3,3,0,0,1,1.75,1.4A3,3,0,0,0,452.89,230Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.66,231.78a3,3,0,1,1-2-3.77A3,3,0,0,1,458.66,231.78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.8,
    y: 110.95,
    width: 63.66,
    height: 33.12,
    transform: "translate(-18.44 170.45) rotate(-24.6)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.49,125l-8.76-19.13a3.4,3.4,0,0,1-4.5-1.67l-46.79,21.42a3.4,3.4,0,0,1-1.67,4.5l8.76,19.13a3.39,3.39,0,0,1,4.5,1.68l46.78-21.43A3.39,3.39,0,0,1,412.49,125Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.63,
    cy: 127.51,
    r: 8.7,
    transform: "translate(1.31 258.89) rotate(-37.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,131.74l.65,1.42-.62.28-.64-1.4a5.11,5.11,0,0,1-3.47.22l0-.87a4.59,4.59,0,0,0,3.08-.15L381.53,128c-1.52.29-3.09.51-3.84-1.13-.54-1.18-.16-2.6,1.66-3.61l-.65-1.43.62-.28L380,123a5.27,5.27,0,0,1,2.86-.38l0,.87a5,5,0,0,0-2.53.29l1.5,3.28c1.55-.31,3.2-.59,4,1.07C386.33,129.28,385.9,130.73,384,131.74Zm-2.86-4.61L379.72,124c-1.23.69-1.5,1.61-1.14,2.39C379,127.37,380,127.33,381.13,127.13Zm3.77,1.41c-.44-1-1.5-.9-2.68-.67l1.41,3.09C385,130.24,385.26,129.33,384.9,128.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.58,
    y: 237.71,
    width: 44.51,
    height: 23.15,
    transform: "matrix(1, -0.09, 0.09, 1, -21.24, 6.25)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75,254.86l-1.26-14.65a2.38,2.38,0,0,1-2.57-2.16l-35.84,3.1a2.39,2.39,0,0,1-2.16,2.57l1.26,14.65a2.37,2.37,0,0,1,2.57,2.16l35.84-3.1A2.39,2.39,0,0,1,82.75,254.86Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9,248.77a6.09,6.09,0,1,1-6.59-5.54A6.08,6.08,0,0,1,67.9,248.77Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4,252.63l.09,1.09-.47,0-.1-1.08a3.57,3.57,0,0,1-2.33-.67l.22-.56a3.26,3.26,0,0,0,2.06.62l-.21-2.49c-1.07-.16-2.16-.39-2.26-1.64-.08-.91.5-1.76,1.94-2l-.09-1.09.47,0,.09,1.07a3.76,3.76,0,0,1,2,.43l-.19.57a3.56,3.56,0,0,0-1.73-.4l.21,2.51c1.09.16,2.25.37,2.36,1.64C64.52,251.56,63.89,252.41,62.4,252.63Zm-.8-3.71-.21-2.37c-1,.17-1.36.71-1.31,1.31S60.8,248.79,61.6,248.92Zm2.15,1.82c-.07-.75-.78-1-1.61-1.08l.2,2.37C63.38,251.86,63.8,251.34,63.75,250.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.33,
    cy: 104.01,
    r: 8.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.72,108.84v1.56H444v-1.55a5.18,5.18,0,0,1-3.25-1.23l.39-.78A4.69,4.69,0,0,0,444,108v-3.57c-1.5-.37-3-.83-3-2.63,0-1.3.94-2.43,3-2.59V97.62h.68v1.55a5.27,5.27,0,0,1,2.76.85l-.34.8a5,5,0,0,0-2.42-.79v3.6c1.53.37,3.15.8,3.15,2.63C447.87,107.57,446.88,108.72,444.72,108.84Zm-.68-5.39v-3.39c-1.4.12-2,.84-2,1.7C442,102.79,442.92,103.17,444,103.45Zm2.84,2.86c0-1.07-1-1.44-2.16-1.73V108C446.21,107.87,446.88,107.18,446.88,106.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.04,
    cy: 211.92,
    r: 8.7,
    transform: "translate(-38.35 93.98) rotate(-13.26)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.84,216.24l-.81,1.33-.58-.36.81-1.32a5.09,5.09,0,0,1-2.12-2.75l.74-.46a4.66,4.66,0,0,0,1.83,2.47l1.88-3.05c-1.09-1.09-2.14-2.28-1.2-3.81.68-1.11,2.07-1.58,3.93-.63l.82-1.34.58.36-.81,1.32a5.42,5.42,0,0,1,1.91,2.16l-.71.51a5.1,5.1,0,0,0-1.65-1.94l-1.89,3.07c1.12,1.12,2.27,2.33,1.31,3.89C386.19,216.81,384.75,217.26,382.84,216.24Zm2.25-5,1.77-2.89c-1.25-.63-2.16-.35-2.61.38C383.71,209.66,384.28,210.47,385.09,211.29Zm.92,3.92c.56-.91-.09-1.74-.94-2.6l-1.78,2.9C384.62,216.2,385.55,216,386,215.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.18,44a8.7,8.7,0,1,1-11.53-4.3A8.69,8.69,0,0,1,260.18,44Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.63,51.83l.65,1.42-.62.29L254,52.13a5.11,5.11,0,0,1-3.47.22l0-.87a4.62,4.62,0,0,0,3.07-.14l-1.48-3.26c-1.52.29-3.09.5-3.84-1.13-.54-1.19-.16-2.6,1.67-3.61l-.65-1.43.61-.28.65,1.41a5.27,5.27,0,0,1,2.86-.38l0,.87a5.05,5.05,0,0,0-2.53.29l1.5,3.28c1.55-.31,3.2-.58,4,1.07C257,49.37,256.54,50.82,254.63,51.83Zm-2.86-4.61-1.41-3.09c-1.23.69-1.5,1.61-1.14,2.38C249.65,47.45,250.64,47.42,251.77,47.22Zm3.77,1.41c-.45-1-1.5-.89-2.68-.67l1.41,3.09C255.58,50.33,255.9,49.43,255.54,48.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.88,396.33a13.07,13.07,0,1,1-17.32-6.46A13.07,13.07,0,0,1,230.88,396.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.53,408.11l1,2.14-.93.42-1-2.12a7.66,7.66,0,0,1-5.21.34l.06-1.3a6.93,6.93,0,0,0,4.61-.23l-2.23-4.88c-2.27.43-4.64.75-5.76-1.7-.82-1.78-.24-3.91,2.5-5.43l-1-2.13.92-.43,1,2.12a8,8,0,0,1,4.3-.57l0,1.3a7.54,7.54,0,0,0-3.79.44l2.24,4.92c2.33-.46,4.81-.87,5.95,1.61C226.05,404.42,225.41,406.6,222.53,408.11Zm-4.28-6.93-2.13-4.64c-1.83,1-2.24,2.41-1.7,3.59C215.06,401.54,216.54,401.49,218.25,401.18Zm5.66,2.13c-.67-1.47-2.26-1.35-4-1l2.12,4.64C224,405.86,224.45,404.5,223.91,403.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.66,193.23a13.07,13.07,0,1,1,1.19-18.45A13.07,13.07,0,0,1,43.66,193.23Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,188.63l-1.76,1.55-.68-.77,1.75-1.53a7.75,7.75,0,0,1-1.83-4.9l1.27-.32A7,7,0,0,0,30.26,187l4-3.54c-1.07-2.05-2.06-4.23,0-6,1.48-1.29,3.68-1.35,5.92.83L42,176.75l.67.76-1.75,1.54A8,8,0,0,1,42.66,183l-1.24.41a7.67,7.67,0,0,0-1.51-3.51l-4.07,3.57c1.11,2.09,2.22,4.35.17,6.16C34.52,190.93,32.25,191,30,188.63Zm5.4-6.1,3.83-3.37c-1.52-1.46-3-1.45-3.92-.6C34.11,179.58,34.59,181,35.37,182.53Zm-.41,6c1.22-1.06.65-2.55-.19-4.15l-3.83,3.37C32.54,189.36,34,189.42,35,188.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.56,
    cy: 303.17,
    r: 6.31,
    transform: "matrix(0.04, -1, 1, 0.04, -209.85, 388.89)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,305.68l.72.87-.37.31-.72-.86a3.72,3.72,0,0,1-2.39.82l-.14-.62a3.37,3.37,0,0,0,2.12-.68l-1.66-2c-1,.49-2.06.94-2.9-.06-.6-.72-.6-1.79.48-2.85l-.73-.87.38-.31.72.86a3.87,3.87,0,0,1,1.93-.81l.18.6a3.79,3.79,0,0,0-1.71.69l1.67,2c1-.51,2.13-1,3,0C100.19,303.51,100.17,304.61,99,305.68ZM96.14,303l-1.58-1.89c-.72.72-.73,1.41-.34,1.89S95.39,303.35,96.14,303Zm2.91.27c-.5-.59-1.22-.34-2,.05l1.58,1.89C99.4,304.45,99.45,303.75,99.05,303.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.59,429.17a6.31,6.31,0,1,1-8.89-.81A6.32,6.32,0,0,1,297.59,429.17Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.19,435.72l.73.87-.38.31-.72-.86a3.69,3.69,0,0,1-2.38.82l-.14-.62a3.31,3.31,0,0,0,2.12-.68l-1.66-2c-1,.49-2.07.94-2.9-.06-.61-.72-.61-1.79.47-2.85l-.72-.87.38-.31.72.86a3.79,3.79,0,0,1,1.93-.81l.18.6a3.83,3.83,0,0,0-1.72.69l1.68,2c1-.51,2.13-1,3,0C296.36,433.55,296.34,434.65,295.19,435.72ZM292.32,433l-1.58-1.89c-.73.72-.74,1.41-.34,1.89S291.56,433.39,292.32,433Zm2.9.28c-.5-.6-1.22-.35-2,0l1.58,1.89C295.58,434.49,295.63,433.79,295.22,433.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.61,
    cy: 69.11,
    r: 6.31,
    transform: "translate(38.95 180.91) rotate(-84.76)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,71.62l.72.87-.38.31-.72-.86a3.67,3.67,0,0,1-2.38.82l-.14-.62a3.37,3.37,0,0,0,2.12-.68l-1.66-2c-1,.49-2.07.94-2.9-.06-.6-.72-.61-1.79.48-2.85l-.73-.87.38-.31.72.86a3.83,3.83,0,0,1,1.93-.81l.18.6a3.79,3.79,0,0,0-1.71.69l1.67,2c1-.51,2.13-1,3,0C122.24,69.45,122.21,70.55,121.07,71.62Zm-2.88-2.69L116.61,67c-.72.72-.74,1.41-.34,1.89S117.43,69.29,118.19,68.93Zm2.91.27c-.5-.59-1.23-.34-2,0l1.58,1.89C121.45,70.39,121.5,69.69,121.1,69.2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.81,327.81s-7.71,39.13-55,48c0,0-12.35,9.85-16.46,15.68s-26,15.74-48.3,46.66-55.5-67.27-55.5-67.27l73.38-95.3Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.84,144.08s25.5-12.47,31.11-10.32,11,15.05-10.45,27.4-15.05,35.36-15.05,35.36h15.3s9.18,3.74,12.75,8.55,6.12,21.21,8.16,26.77,1,11.13-4.59,12.94c0,0-3.57,15.56-2.55,22.46s.51,11.34-6.12,12.18a11.57,11.57,0,0,1-12.75-12.18l-5.1,18.48,3.57,7.1a46.16,46.16,0,0,1,13.77,8.34c7.14,6.12,14.28,7.79,12.24,14.61s-6.12,14.17-27.54,5.65-39.27-42-39.27-42L263.45,162.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.68,211.14c-11.56,15.76,1.23,33.91,1.23,33.91s-8,4.46-8.23,15.84c-.09,4.73,1.1,11.34,2.52,17.46a11.46,11.46,0,0,1-6.54-11.11l-5.11,18.48,3.57,7.09a43.77,43.77,0,0,1,10.52,5.79c-3.17,7.28-4.14,16.28-3.86,25.56a68.24,68.24,0,0,1-8.19-2.74c-21.42-8.53-39.27-42-39.27-42L263.45,162.67l39.39-18.59s13.93-6.81,23.47-9.5c-.74,8.92,1,18.15,2.26,23.29a53.8,53.8,0,0,1-5.07,3.29c-21.42,12.35-15.05,35.36-15.05,35.36h15.31s8.72,3.56,12.46,8.19A25,25,0,0,0,329.68,211.14Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,309s-27.74,54.39-77.74,66.73c0,0-1.91,10.76-10.37,15.38-4.52,2.46-22.76,29.79-38.77,54.74L47.44,391.45c5.46-5.4,11.68-11.62,18-18.11,18.5-18.86,38.24-40,44.28-50.46,5.4-9.3,12.23-25.44,18.18-40.61,7.62-19.4,13.82-37.22,13.82-37.22l29.56-32.86,46.47-51.67,2,6.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.79,160.52,263,309s-27.74,54.39-77.74,66.73c0,0-1.91,10.76-10.37,15.38-4.06,2.21-19.17,24.46-33.79,47,5.42-18.6,21.11-48.25,21.11-48.25-10.07-11.93-7.13-24.5-3.1-20.92s14.16,13.64,14.8,14.27c-4.45-5.24-5.48-13.45-5.48-13.45s12.48,8.3,13.49-5-7.48-45.8-7.48-45.8L152.15,233.5Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.45,162.68l39.39-18.6s25.5-12.47,31.11-10.32,11,15.05-10.45,27.4-15.05,35.36-15.05,35.36h15.3s9.18,3.74,12.75,8.55,6.12,21.21,8.16,26.77,1,11.13-4.59,12.94c0,0-3.57,15.56-2.55,22.46s.51,11.34-6.12,12.18a11.57,11.57,0,0,1-12.75-12.18l-5.1,18.48,3.57,7.1a46.16,46.16,0,0,1,13.77,8.34c7.14,6.12,14.28,7.79,12.24,14.61s-6.12,14.17-27.54,5.65-39.27-42-39.27-42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.07,244.78c-7.65,2.07-16.57.54-19.89-13s3.32-28,7.65-29.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.65,267.24s-.51-17.41,5.87-21.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.62,353.71s-18.69-2.33-22.86-10.69c-3.45-6.92-22.15,19-44.28,30.32,18.5-18.86,38.24-40,44.28-50.46,5.4-9.3,12.23-25.44,18.18-40.61v0c-.3,12.58-7,31.84-5.09,41.87a8.05,8.05,0,0,0-5.75,9.74C118.53,341.85,132.62,353.71,132.62,353.71Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,309s-27.74,54.39-77.75,66.73c0,0-1.9,10.76-10.36,15.38-4.52,2.46-22.75,29.79-38.78,54.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.44,391.45c21.36-21.11,54.19-54.58,62.32-68.57,12.3-21.17,32-77.84,32-77.84l76-84.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.39,225.07s11.68,10.46,15,20",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.86,
    y: 72.72,
    width: 139.13,
    height: 280.99,
    rx: 6.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,80.37l-2.66,4.87A3.32,3.32,0,0,1,271.43,87h-44a3.35,3.35,0,0,1-2.92-1.74l-2.65-4.87a3.32,3.32,0,0,0-2.92-1.74H188.19A3.33,3.33,0,0,0,184.87,82V345a3.33,3.33,0,0,0,3.32,3.33H310.65A3.33,3.33,0,0,0,314,345V82a3.33,3.33,0,0,0-3.33-3.33H279.93A3.32,3.32,0,0,0,277,80.37Z",
    style: {
      fill: "#FAA700",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.88,
    cy: 80.94,
    r: 1.79,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.75,80.94a1.11,1.11,0,1,1-1.11-1.12A1.11,1.11,0,0,1,260.75,80.94Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77,80.24H244.89a.69.69,0,0,0-.69.7h0a.69.69,0,0,0,.69.69h10.88a.69.69,0,0,0,.69-.69h0A.69.69,0,0,0,255.77,80.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.91,
    y: 85.32,
    width: 11.73,
    height: 4.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.63,
    y: 86.16,
    width: 1.82,
    height: 3.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.68,
    y: 88.5,
    width: 2.08,
    height: 1.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.74,
    y: 86.68,
    width: 2.08,
    height: 3.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 84.86,
    width: 2.08,
    height: 5.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.85,
    y: 83.04,
    width: 2.08,
    height: 7.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.7,
    y: 136.76,
    width: 127.44,
    height: 121.55,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.9,117.35v2.11c0,2.61-1.25,4-3.81,4h-1.21v6.11h-2.56V113.32h3.77C219.65,113.32,220.9,114.74,220.9,117.35Zm-5-1.7v5.51h1.21c.81,0,1.25-.37,1.25-1.53v-2.45c0-1.16-.44-1.53-1.25-1.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.07,129.6h-2.58l-.45-2.95h-3.13l-.45,2.95h-2.35l2.61-16.28h3.74Zm-5.84-5.16h2.47l-1.21-8.23h-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.51,124.21l-3.23-10.89H232l1.93,7.42h.05l1.93-7.42h2.44l-3.23,10.89v5.39h-2.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.72,124.88h.05l1.72-11.56h3.56V129.6h-2.42V117.93h0l-1.72,11.67h-2.42l-1.86-11.51h0V129.6H239.3V113.32h3.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.47,120.18H258v2.33h-3.51v4.77h4.42v2.32h-7V113.32h7v2.33h-4.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,117.81h-.05V129.6h-2.3V113.32h3.21l2.58,9.75h0v-9.75h2.28V129.6h-2.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.66,113.32h7.91v2.33h-2.68V129.6h-2.56V115.65h-2.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,113.14c2.48,0,3.76,1.49,3.76,4.09v.51h-2.42v-.67c0-1.17-.46-1.61-1.28-1.61s-1.27.44-1.27,1.61.51,2.07,2.18,3.53c2.14,1.89,2.82,3.23,2.82,5.09,0,2.61-1.31,4.1-3.82,4.1s-3.81-1.49-3.81-4.1v-1h2.42v1.17c0,1.16.51,1.58,1.32,1.58s1.33-.42,1.33-1.58-.51-2.07-2.19-3.54c-2.14-1.88-2.81-3.23-2.81-5.09C278.36,114.63,279.64,113.14,282.13,113.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.91,
    y: 151.49,
    width: 107.02,
    height: 15.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.91,
    y: 181.48,
    width: 107.02,
    height: 15.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.91,
    y: 208.75,
    width: 107.02,
    height: 15.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.91,
    y: 230.57,
    width: 50.67,
    height: 18.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.27,
    y: 230.57,
    width: 50.67,
    height: 18.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,148.7v.43h-3.35V144.4h3.25v.43h-2.74v1.69h2.44v.42h-2.44v1.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.52,147.07v2.06H209v-2c0-.75-.38-1.14-1-1.14a1.15,1.15,0,0,0-1.19,1.29v1.86h-.48v-2c0-.75-.38-1.14-1-1.14a1.15,1.15,0,0,0-1.19,1.29v1.86h-.48v-3.55h.46v.65a1.44,1.44,0,0,1,1.31-.68,1.26,1.26,0,0,1,1.26.75,1.56,1.56,0,0,1,1.41-.75A1.34,1.34,0,0,1,209.52,147.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.51,146.93v2.2h-.46v-.55a1.36,1.36,0,0,1-1.23.59c-.8,0-1.29-.42-1.29-1s.35-1,1.37-1H213v-.22c0-.61-.35-.94-1-.94a1.79,1.79,0,0,0-1.18.42l-.22-.36a2.3,2.3,0,0,1,1.45-.48A1.26,1.26,0,0,1,213.51,146.93Zm-.48,1.14v-.59h-1.12c-.69,0-.91.27-.91.64s.33.67.9.67A1.15,1.15,0,0,0,213,148.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.7,144.46a.35.35,0,0,1,.35-.34.34.34,0,1,1,0,.68A.35.35,0,0,1,214.7,144.46Zm.11,1.12h.48v3.55h-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.63,144.12h.48v5h-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.89,161v.43h-3.35v-4.73h3.25v.43H203v1.68h2.45v.43H203V161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.83,159.35v2.06h-.48v-2c0-.75-.38-1.14-1-1.14a1.14,1.14,0,0,0-1.19,1.28v1.87h-.48v-2c0-.75-.38-1.14-1-1.14a1.14,1.14,0,0,0-1.19,1.28v1.87H207v-3.56h.46v.65a1.45,1.45,0,0,1,1.31-.67,1.28,1.28,0,0,1,1.26.75,1.55,1.55,0,0,1,1.41-.75A1.34,1.34,0,0,1,212.83,159.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.81,159.21v2.2h-.46v-.55a1.33,1.33,0,0,1-1.22.58c-.8,0-1.3-.42-1.3-1s.36-1,1.38-1h1.13v-.21c0-.61-.35-.94-1-.94a1.83,1.83,0,0,0-1.19.42l-.21-.36a2.22,2.22,0,0,1,1.45-.48A1.26,1.26,0,0,1,216.81,159.21Zm-.47,1.13v-.58h-1.12c-.69,0-.91.27-.91.64s.33.67.9.67A1.14,1.14,0,0,0,216.34,160.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,156.73a.35.35,0,0,1,.35-.34.34.34,0,0,1,.35.34.35.35,0,1,1-.7,0Zm.11,1.12h.48v3.56h-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.94,156.39h.47v5h-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,159.35v2.06h-.48v-2a1,1,0,0,0-1.06-1.14,1.16,1.16,0,0,0-1.25,1.28v1.87h-.48v-3.56h.46v.66a1.5,1.5,0,0,1,1.35-.68A1.36,1.36,0,0,1,225,159.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,159.21v2.2h-.46v-.55a1.33,1.33,0,0,1-1.22.58c-.81,0-1.3-.42-1.3-1s.35-1,1.37-1h1.13v-.21c0-.61-.34-.94-1-.94a1.79,1.79,0,0,0-1.18.42l-.22-.36a2.24,2.24,0,0,1,1.45-.48A1.26,1.26,0,0,1,229,159.21Zm-.48,1.13v-.58h-1.11c-.69,0-.92.27-.92.64s.33.67.9.67A1.14,1.14,0,0,0,228.53,160.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.18,159.35v2.06h-.48v-2c0-.75-.38-1.14-1-1.14a1.14,1.14,0,0,0-1.19,1.28v1.87H233v-2c0-.75-.38-1.14-1-1.14a1.14,1.14,0,0,0-1.19,1.28v1.87h-.48v-3.56h.46v.65a1.45,1.45,0,0,1,1.31-.67,1.26,1.26,0,0,1,1.26.75,1.56,1.56,0,0,1,1.41-.75A1.34,1.34,0,0,1,236.18,159.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.59,159.78h-3A1.32,1.32,0,0,0,239,161a1.41,1.41,0,0,0,1.09-.47l.27.31a1.88,1.88,0,0,1-3.24-1.23,1.71,1.71,0,0,1,1.74-1.8,1.69,1.69,0,0,1,1.72,1.8S240.59,159.73,240.59,159.78Zm-3-.36h2.52a1.26,1.26,0,0,0-2.52,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.55,159.62c0,1.15-.43,1.82-1.13,1.82a.72.72,0,0,1-.76-.73,1.51,1.51,0,0,1-1.35.73,1.74,1.74,0,0,1,0-3.48,1.5,1.5,0,0,1,1.34.71V158h.44v2.56c0,.38.19.52.42.52.41,0,.68-.52.68-1.43a2.58,2.58,0,0,0-2.77-2.65,2.72,2.72,0,1,0,0,5.44,3,3,0,0,0,1.3-.3l.11.33a3.26,3.26,0,0,1-1.41.31,3.06,3.06,0,1,1,0-6.12A2.92,2.92,0,0,1,247.55,159.62Zm-1.9.07a1.29,1.29,0,1,0-2.57,0,1.29,1.29,0,1,0,2.57,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.65,159.78h-3a1.32,1.32,0,0,0,1.4,1.24,1.41,1.41,0,0,0,1.09-.47l.27.31a1.88,1.88,0,0,1-3.24-1.23,1.71,1.71,0,0,1,1.74-1.8,1.69,1.69,0,0,1,1.72,1.8S251.65,159.73,251.65,159.78Zm-3-.36h2.52a1.26,1.26,0,0,0-2.52,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.51,159.35v2.06H258v-2c0-.75-.38-1.14-1-1.14a1.14,1.14,0,0,0-1.19,1.28v1.87h-.48v-2c0-.75-.38-1.14-1-1.14a1.14,1.14,0,0,0-1.19,1.28v1.87h-.48v-3.56h.46v.65a1.44,1.44,0,0,1,1.3-.67,1.29,1.29,0,0,1,1.27.75,1.53,1.53,0,0,1,1.4-.75A1.34,1.34,0,0,1,258.51,159.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.49,159.21v2.2H262v-.55a1.34,1.34,0,0,1-1.22.58c-.81,0-1.3-.42-1.3-1s.35-1,1.37-1H262v-.21c0-.61-.34-.94-1-.94a1.79,1.79,0,0,0-1.18.42l-.22-.36a2.24,2.24,0,0,1,1.45-.48A1.26,1.26,0,0,1,262.49,159.21Zm-.48,1.13v-.58H260.9c-.69,0-.92.27-.92.64s.33.67.9.67A1.14,1.14,0,0,0,262,160.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.69,156.73a.35.35,0,1,1,.35.35A.35.35,0,0,1,263.69,156.73Zm.1,1.12h.48v3.56h-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,156.39h.48v5h-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.12,161.07a.35.35,0,0,1,.36-.36.36.36,0,0,1,.36.36.37.37,0,0,1-.36.37A.36.36,0,0,1,267.12,161.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.4,159.63a1.75,1.75,0,0,1,1.83-1.8,1.55,1.55,0,0,1,1.4.7l-.36.24a1.22,1.22,0,0,0-1-.52,1.39,1.39,0,0,0,0,2.77,1.2,1.2,0,0,0,1-.52l.36.24a1.57,1.57,0,0,1-1.4.7A1.75,1.75,0,0,1,268.4,159.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.15,159.63a1.81,1.81,0,1,1,1.81,1.81A1.75,1.75,0,0,1,272.15,159.63Zm3.13,0A1.33,1.33,0,1,0,274,161,1.3,1.3,0,0,0,275.28,159.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,159.35v2.06h-.48v-2c0-.75-.38-1.14-1-1.14a1.14,1.14,0,0,0-1.19,1.28v1.87h-.48v-2c0-.75-.38-1.14-1-1.14a1.14,1.14,0,0,0-1.19,1.28v1.87h-.48v-3.56h.46v.65a1.44,1.44,0,0,1,1.3-.67,1.29,1.29,0,0,1,1.27.75,1.54,1.54,0,0,1,1.4-.75A1.34,1.34,0,0,1,282.61,159.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.39,189.56l.84.48-.15.28-.85-.49v1h-.31v-1l-.85.49-.16-.28.85-.48-.85-.47.16-.29.85.5v-1h.31v1l.85-.5.15.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.14,189.56l.84.48-.16.28-.84-.49v1h-.32v-1l-.84.49-.17-.28.85-.48-.85-.47.17-.29.84.5v-1H206v1l.84-.5.16.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.88,189.56l.84.48-.16.28-.84-.49v1h-.31v-1l-.84.49-.16-.28.84-.48-.84-.47.16-.29.84.5v-1h.31v1l.84-.5.16.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.62,189.56l.84.48-.15.28-.85-.49v1h-.31v-1l-.85.49-.16-.28.85-.48-.85-.47.16-.29.85.5v-1h.31v1l.85-.5.15.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,189.56l.84.48-.16.28-.84-.49v1h-.32v-1l-.84.49-.17-.28.85-.48-.85-.47.17-.29.84.5v-1h.32v1l.84-.5.16.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.11,189.56l.84.48-.16.28-.84-.49v1h-.31v-1l-.84.49-.16-.28.84-.48-.84-.47.16-.29.84.5v-1H217v1l.84-.5.16.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.85,189.56l.84.48-.15.28-.85-.49v1h-.31v-1l-.85.49-.16-.28.85-.48-.85-.47.16-.29.85.5v-1h.31v1l.85-.5.15.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6,189.56l.84.48-.16.28-.85-.49v1h-.31v-1l-.84.49-.17-.28.85-.48-.85-.47.17-.29.84.5v-1h.31v1l.85-.5.16.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,189.56l.84.48-.16.28-.84-.49v1h-.31v-1l-.84.49-.16-.28.84-.48-.84-.47.16-.29.84.5v-1h.31v1l.84-.5.16.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.08,189.56l.84.48-.15.28-.85-.49v1h-.31v-1l-.85.49-.16-.28.84-.48-.84-.47.16-.29.85.5v-1h.31v1l.85-.5.15.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83,189.56l.83.48-.15.28-.85-.49v1h-.31v-1l-.84.49-.17-.28.85-.48-.85-.47.17-.29.84.5v-1h.31v1l.85-.5.15.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,176c0,1-.73,1.62-1.93,1.62h-1.27v1.49h-.51V174.4H201C202.21,174.4,202.94,175,202.94,176Zm-.5,0c0-.76-.5-1.19-1.45-1.19h-1.25v2.37H201C201.94,177.2,202.44,176.77,202.44,176Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57,176.93v2.2h-.46v-.55a1.35,1.35,0,0,1-1.23.58c-.8,0-1.29-.41-1.29-1s.35-1,1.37-1h1.13v-.21c0-.61-.35-.94-1-.94a1.79,1.79,0,0,0-1.18.42l-.22-.36a2.24,2.24,0,0,1,1.45-.48A1.26,1.26,0,0,1,206.57,176.93Zm-.48,1.13v-.58H205c-.69,0-.91.27-.91.64s.33.67.9.67A1.14,1.14,0,0,0,206.09,178.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.38,178.73l.21-.38a2.2,2.2,0,0,0,1.27.4c.67,0,.95-.23.95-.59,0-.92-2.3-.19-2.3-1.6,0-.58.5-1,1.4-1a2.45,2.45,0,0,1,1.26.33l-.21.38a1.86,1.86,0,0,0-1.05-.3c-.64,0-.92.25-.92.59,0,1,2.3.24,2.3,1.6,0,.62-.54,1-1.47,1A2.37,2.37,0,0,1,207.38,178.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.68,178.73l.22-.38a2.15,2.15,0,0,0,1.26.4c.68,0,1-.23,1-.59,0-.92-2.3-.19-2.3-1.6,0-.58.5-1,1.41-1a2.39,2.39,0,0,1,1.25.33l-.21.38a1.85,1.85,0,0,0-1-.3c-.65,0-.93.25-.93.59,0,1,2.3.24,2.3,1.6,0,.62-.54,1-1.46,1A2.38,2.38,0,0,1,210.68,178.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.63,175.58l-1.35,3.55h-.45l-1.12-2.91-1.12,2.91h-.46l-1.33-3.55h.46l1.11,3,1.14-3h.42l1.13,3,1.13-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.89,177.35a1.81,1.81,0,1,1,1.81,1.81A1.75,1.75,0,0,1,219.89,177.35Zm3.13,0a1.32,1.32,0,1,0-2.64,0,1.32,1.32,0,1,0,2.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.28,175.55V176h-.12a1.15,1.15,0,0,0-1.19,1.31v1.81h-.48v-3.55H225v.69A1.33,1.33,0,0,1,226.28,175.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.35,174.12v5h-.46v-.7a1.53,1.53,0,0,1-1.37.73,1.81,1.81,0,0,1,0-3.61,1.54,1.54,0,0,1,1.35.7v-2.13Zm-.47,3.23a1.32,1.32,0,1,0-1.32,1.39A1.3,1.3,0,0,0,229.88,177.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46,215v4.74H237v-4.3h-1.12V215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82,219.28v.44H238.5v-.35l2-1.93c.53-.52.64-.84.64-1.16,0-.55-.39-.89-1.11-.89a1.59,1.59,0,0,0-1.29.53l-.35-.3a2.14,2.14,0,0,1,1.68-.68c1,0,1.57.49,1.57,1.28a2,2,0,0,1-.78,1.48l-1.61,1.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,218.36c0,.79-.58,1.4-1.72,1.4a2.46,2.46,0,0,1-1.7-.61l.23-.39a2.09,2.09,0,0,0,1.47.55c.79,0,1.22-.36,1.22-.95s-.4-.94-1.28-.94h-.34v-.36l1.31-1.64h-2.42V215h3v.35L244,217C245.05,217.07,245.56,217.6,245.56,218.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,218.47h-.95v1.25h-.48v-1.25h-2.67v-.35l2.51-3.14h.54L246.79,218h2.05v-1.1h.47V218h.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.69,218.32c0,.81-.56,1.44-1.72,1.44a2.47,2.47,0,0,1-1.7-.61l.24-.39a2,2,0,0,0,1.45.55c.81,0,1.23-.39,1.23-1s-.38-1-1.58-1h-1l.25-2.38h2.59v.44h-2.17l-.16,1.5h.61C255.15,216.92,255.69,217.49,255.69,218.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.86,218.3a1.48,1.48,0,0,1-1.62,1.46c-1.26,0-1.94-.88-1.94-2.37s.88-2.45,2.16-2.45a2.22,2.22,0,0,1,1.13.26l-.2.39a1.68,1.68,0,0,0-.92-.22c-1,0-1.68.65-1.68,1.94,0,.11,0,.24,0,.38a1.53,1.53,0,0,1,1.45-.81A1.44,1.44,0,0,1,259.86,218.3Zm-.48,0c0-.63-.46-1-1.19-1a1.09,1.09,0,0,0-1.22,1c0,.52.43,1,1.25,1A1,1,0,0,0,259.38,218.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.7,215v.35l-2,4.39h-.53l1.95-4.3h-2.43v.88h-.48V215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.85,218.4c0,.84-.71,1.36-1.84,1.36s-1.82-.52-1.82-1.36a1.19,1.19,0,0,1,.91-1.17,1,1,0,0,1-.74-1c0-.77.65-1.25,1.65-1.25s1.67.48,1.67,1.25a1.06,1.06,0,0,1-.76,1A1.2,1.2,0,0,1,267.85,218.4Zm-.5,0c0-.58-.5-.95-1.34-.95s-1.33.37-1.33.95.49,1,1.33,1S267.35,219,267.35,218.39ZM266,217.06c.74,0,1.18-.33,1.18-.85s-.47-.85-1.18-.85-1.17.32-1.17.85S265.27,217.06,266,217.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.71,217.31c0,1.61-.88,2.45-2.17,2.45a2.21,2.21,0,0,1-1.12-.26l.2-.39a1.68,1.68,0,0,0,.92.22c1,0,1.67-.66,1.67-1.94a2.62,2.62,0,0,0,0-.38,1.5,1.5,0,0,1-1.44.81,1.44,1.44,0,0,1-1.6-1.42,1.48,1.48,0,0,1,1.62-1.46C273,214.94,273.71,215.82,273.71,217.31Zm-.67-.94c0-.52-.43-1-1.25-1a1,1,0,0,0-1.16,1c0,.63.46,1,1.19,1A1.1,1.1,0,0,0,273,216.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.71,215v4.74h-.49v-4.3H274.1V215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.83,217.35c0-1.51.8-2.41,1.89-2.41s1.89.9,1.89,2.41-.79,2.41-1.89,2.41S276.83,218.86,276.83,217.35Zm3.28,0c0-1.26-.56-2-1.39-2s-1.39.7-1.39,2,.57,2,1.39,2S280.11,218.61,280.11,217.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,215v4.74h-.49v-4.3H281V215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.82,215v4.74h-.49v-4.3h-1.12V215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.25,215v4.74h-.48v-4.3h-1.12V215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.61,219.28v.44h-3.32v-.35l2-1.93c.53-.52.64-.84.64-1.16,0-.55-.39-.89-1.11-.89a1.59,1.59,0,0,0-1.29.53l-.35-.3a2.16,2.16,0,0,1,1.68-.68c1,0,1.57.49,1.57,1.28a2,2,0,0,1-.78,1.48L291,219.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,215v4.74H295v-4.3h-1.11V215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.79,213.9v-.72a1.26,1.26,0,0,0-1.26-1.26H201.76a1.26,1.26,0,0,0-1.26,1.26v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5,214.89v5.3a1.26,1.26,0,0,0,1.26,1.26h12.77a1.26,1.26,0,0,0,1.26-1.26v-5.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.69,242.8c0-1.51.79-2.4,1.89-2.4s1.89.89,1.89,2.4-.8,2.41-1.89,2.41S200.69,244.31,200.69,242.8Zm3.28,0c0-1.26-.57-2-1.39-2s-1.39.7-1.39,2,.56,2,1.39,2S204,244.07,204,242.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.8,243.85c0,.84-.71,1.36-1.84,1.36s-1.82-.52-1.82-1.36a1.17,1.17,0,0,1,.91-1.16,1.07,1.07,0,0,1-.74-1c0-.77.65-1.25,1.65-1.25s1.67.48,1.67,1.25a1.08,1.08,0,0,1-.75,1A1.18,1.18,0,0,1,208.8,243.85Zm-.5,0c0-.58-.5-.94-1.34-.94s-1.33.36-1.33.94.5,1,1.33,1S208.3,244.43,208.3,243.84ZM207,242.51c.74,0,1.18-.33,1.18-.84s-.47-.86-1.18-.86-1.17.32-1.17.85S206.23,242.51,207,242.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.19,239.48h.44l-2.24,6.36H209Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,244.73v.44h-3.32v-.35l2-1.92c.53-.53.63-.85.63-1.17,0-.55-.38-.89-1.1-.89a1.61,1.61,0,0,0-1.3.53l-.34-.3a2.12,2.12,0,0,1,1.68-.67c1,0,1.56.48,1.56,1.27a1.94,1.94,0,0,1-.77,1.48l-1.61,1.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,243.77c0,.81-.56,1.44-1.72,1.44a2.47,2.47,0,0,1-1.7-.61l.24-.39a2,2,0,0,0,1.45.55c.81,0,1.23-.39,1.23-1s-.37-1-1.58-1h-1l.24-2.37h2.59v.43h-2.17l-.16,1.51h.61C218.25,242.38,218.79,242.94,218.79,243.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.9,237.39v.27h-2.08v-2.94h2V235h-1.7v1h1.52v.27h-1.52v1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43,237.66l-.94-1.3-1,1.3h-.36l1.12-1.51-1-1.43h.35l.89,1.2.88-1.2h.33l-1,1.42,1.12,1.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.55,235.73c0,.62-.46,1-1.2,1h-.79v.93h-.31v-2.94h1.1C208.09,234.72,208.55,235.1,208.55,235.73Zm-.31,0c0-.47-.31-.74-.9-.74h-.78v1.47h.78C207.93,236.46,208.24,236.19,208.24,235.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,234.72h1.19a1.47,1.47,0,1,1,0,2.94h-1.19Zm1.17,2.67a1.2,1.2,0,1,0,0-2.4h-.86v2.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.44,236.29v1.37h-.29v-.35a.82.82,0,0,1-.76.37c-.49,0-.8-.26-.8-.64s.22-.63.85-.63h.7v-.13a.54.54,0,0,0-.62-.59,1.13,1.13,0,0,0-.74.26l-.13-.22a1.39,1.39,0,0,1,.9-.3A.78.78,0,0,1,215.44,236.29Zm-.3.7v-.36h-.69c-.43,0-.57.17-.57.4s.21.41.56.41A.7.7,0,0,0,215.14,237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.41,237.52a.66.66,0,0,1-.46.16.59.59,0,0,1-.65-.64V235.7h-.39v-.25h.39V235h.3v.48h.67v.25h-.67V237a.35.35,0,0,0,.38.4.52.52,0,0,0,.33-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.8,236.65H218a.82.82,0,0,0,.87.76.86.86,0,0,0,.68-.29l.17.2a1.12,1.12,0,0,1-.86.36,1.09,1.09,0,0,1-1.15-1.13,1.06,1.06,0,0,1,1.07-1.12,1,1,0,0,1,1.07,1.12Zm-1.85-.23h1.57a.79.79,0,0,0-1.57,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.54,240.44v4.73h-.48v-4.3h-1.12v-.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.9,244.73v.44h-3.32v-.35l2-1.92c.53-.53.64-.85.64-1.17,0-.55-.39-.89-1.11-.89a1.59,1.59,0,0,0-1.29.53l-.35-.3a2.14,2.14,0,0,1,1.68-.67c1,0,1.57.48,1.57,1.27a2,2,0,0,1-.78,1.48l-1.61,1.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.64,243.81c0,.79-.58,1.4-1.72,1.4a2.46,2.46,0,0,1-1.7-.61l.24-.39a2,2,0,0,0,1.46.55c.79,0,1.22-.36,1.22-.95s-.4-.94-1.28-.94h-.34v-.36l1.31-1.64h-2.42v-.43h3v.34l-1.34,1.68C264.13,242.52,264.64,243.05,264.64,243.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.1,236.19a1.48,1.48,0,0,1,1.54-1.5,1.43,1.43,0,0,1,1.07.43l-.19.2a1.19,1.19,0,0,0-.87-.35,1.22,1.22,0,1,0,0,2.43,1.15,1.15,0,0,0,.87-.35l.19.2a1.4,1.4,0,0,1-1.08.43A1.47,1.47,0,0,1,255.1,236.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.38,234.72l-1,2.94h-.33l-.86-2.51-.86,2.51H259l-1-2.94h.32l.85,2.53.88-2.53h.29l.86,2.54.86-2.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,270.58h-2.64l-.57,1.27h-.52l2.16-4.73h.5l2.16,4.73h-.53Zm-.19-.4L229,267.64l-1.14,2.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.69,270.07a1.75,1.75,0,0,1,1.83-1.81,1.54,1.54,0,0,1,1.39.71l-.35.24a1.23,1.23,0,0,0-1-.53,1.39,1.39,0,0,0,0,2.78,1.24,1.24,0,0,0,1-.52l.35.24a1.56,1.56,0,0,1-1.39.7A1.75,1.75,0,0,1,231.69,270.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.76,271.63a1.11,1.11,0,0,1-.75.25.94.94,0,0,1-1-1V268.7h-.63v-.41H236v-.78h.48v.78h1.09v.41h-1.09v2.12a.57.57,0,0,0,.62.65.83.83,0,0,0,.53-.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.53,267.17a.35.35,0,0,1,.7,0,.35.35,0,0,1-.7,0Zm.11,1.12h.48v3.56h-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.09,270.07a1.81,1.81,0,1,1,1.82,1.81A1.76,1.76,0,0,1,240.09,270.07Zm3.13,0a1.32,1.32,0,1,0-1.31,1.39A1.3,1.3,0,0,0,243.22,270.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,269.79v2.06h-.48v-2a1,1,0,0,0-1.07-1.13,1.16,1.16,0,0,0-1.24,1.28v1.87h-.48v-3.56h.46V269a1.51,1.51,0,0,1,1.35-.69A1.37,1.37,0,0,1,248,269.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.64,267.55v1.86h2.44v.43h-2.44v2h-.5v-4.73h3.24v.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,267.17a.35.35,0,0,1,.7,0,.35.35,0,0,1-.7,0Zm.1,1.12h.48v3.56h-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.35,268.29v3.13a1.55,1.55,0,0,1-1.77,1.77,2.49,2.49,0,0,1-1.66-.54l.24-.37a2.14,2.14,0,0,0,1.4.49c.9,0,1.31-.42,1.31-1.29V271a1.57,1.57,0,0,1-1.38.69,1.73,1.73,0,1,1,0-3.45,1.61,1.61,0,0,1,1.4.71v-.68Zm-.46,1.69a1.35,1.35,0,1,0-1.35,1.31A1.27,1.27,0,0,0,259.89,270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9,268.29v3.56h-.46v-.65a1.42,1.42,0,0,1-1.28.68,1.38,1.38,0,0,1-1.5-1.53v-2.06h.48v2a1,1,0,0,0,1.07,1.14,1.16,1.16,0,0,0,1.21-1.29v-1.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,268.26v.47h-.12a1.16,1.16,0,0,0-1.2,1.32v1.81h-.48v-3.56h.46v.7A1.37,1.37,0,0,1,268,268.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,270.22h-3a1.32,1.32,0,0,0,1.4,1.24,1.41,1.41,0,0,0,1.09-.47l.27.31a1.88,1.88,0,0,1-3.24-1.23,1.72,1.72,0,0,1,1.74-1.81,1.69,1.69,0,0,1,1.72,1.81S272,270.16,272,270.22Zm-3-.36h2.52a1.26,1.26,0,0,0-2.52,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.43,290.82v2.08h-1.85v-2a8.79,8.79,0,0,1-4.63-1.49l1-2.26a7.5,7.5,0,0,0,3.61,1.32v-3.1c-2.07-.51-4.37-1.19-4.37-3.85,0-2,1.43-3.66,4.37-4v-2.06h1.85v2a8.39,8.39,0,0,1,3.77,1.14l-.93,2.28a7.68,7.68,0,0,0-2.84-1v3.16c2.06.48,4.33,1.17,4.33,3.79C236.76,288.8,235.35,290.47,232.43,290.82Zm-1.85-8.2V280c-1,.22-1.38.76-1.38,1.37S229.76,282.36,230.58,282.62Zm3.19,4.47c0-.65-.54-1-1.34-1.28v2.56C233.36,288.17,233.77,287.69,233.77,287.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.71,288.22v2.46h-9.82v-1.95l5-4.74c1.16-1.1,1.36-1.76,1.36-2.4,0-1-.71-1.61-2.08-1.61a3.18,3.18,0,0,0-2.69,1.3l-2.19-1.41a6,6,0,0,1,5.16-2.42c2.9,0,4.83,1.49,4.83,3.85,0,1.26-.36,2.41-2.18,4.1l-3,2.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.92,284.18c0-4.29,2.38-6.73,5.57-6.73s5.57,2.44,5.57,6.73-2.36,6.72-5.57,6.72S248.92,288.47,248.92,284.18Zm8.12,0c0-3-1-4.18-2.55-4.18s-2.52,1.22-2.52,4.18,1,4.17,2.52,4.17S257,287.13,257,284.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.53,284.18c0-4.29,2.38-6.73,5.57-6.73s5.57,2.44,5.57,6.73-2.36,6.72-5.57,6.72S261.53,288.47,261.53,284.18Zm8.11,0c0-3-1-4.18-2.54-4.18s-2.53,1.22-2.53,4.18,1,4.17,2.53,4.17S269.64,287.13,269.64,284.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.15,323.78H228.69a9.71,9.71,0,0,1-9.7-9.7h0a9.71,9.71,0,0,1,9.7-9.71h41.46a9.7,9.7,0,0,1,9.7,9.71h0A9.7,9.7,0,0,1,270.15,323.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,313c0,1.22-.88,1.95-2.33,1.95h-1.54v1.8h-.6v-5.7h2.14C235.24,311.09,236.12,311.82,236.12,313Zm-.61,0c0-.91-.6-1.43-1.74-1.43h-1.52v2.85h1.52C234.91,314.46,235.51,313.94,235.51,313Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.49,314.13v2.66h-.55v-.67a1.62,1.62,0,0,1-1.48.71c-1,0-1.56-.5-1.56-1.25s.42-1.21,1.65-1.21h1.36v-.26c0-.73-.41-1.13-1.21-1.13a2.2,2.2,0,0,0-1.43.5l-.26-.43a2.71,2.71,0,0,1,1.75-.58A1.52,1.52,0,0,1,240.49,314.13Zm-.58,1.37v-.7h-1.34c-.83,0-1.1.33-1.1.77s.4.81,1.08.81A1.36,1.36,0,0,0,239.91,315.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.58,312.5l-2.14,4.8c-.36.84-.81,1.11-1.42,1.11A1.48,1.48,0,0,1,241,318l.27-.43a1.07,1.07,0,0,0,.78.33c.39,0,.65-.18.89-.72l.19-.42-1.92-4.28h.61l1.61,3.65L245,312.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.47,316.83v.94h-.41v-.93a3,3,0,0,1-1.95-.74l.24-.47a2.73,2.73,0,0,0,1.71.69v-2.14c-.9-.22-1.81-.5-1.81-1.58,0-.78.56-1.46,1.81-1.55v-.94h.41V311a3.15,3.15,0,0,1,1.65.5l-.2.48a3.14,3.14,0,0,0-1.45-.47v2.16c.92.22,1.89.48,1.89,1.57C252.36,316.07,251.76,316.76,250.47,316.83Zm-.41-3.22v-2c-.84.07-1.22.5-1.22,1S249.39,313.43,250.06,313.61Zm1.7,1.71c0-.65-.59-.87-1.29-1v2C251.36,316.25,251.76,315.84,251.76,315.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.06,316.27v.52h-4v-.41l2.37-2.33c.64-.63.76-1,.76-1.41,0-.66-.46-1.06-1.33-1.06a2,2,0,0,0-1.56.63l-.42-.36a2.59,2.59,0,0,1,2-.81c1.15,0,1.89.59,1.89,1.54a2.34,2.34,0,0,1-.94,1.78l-1.94,1.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76,313.94c0-1.82.95-2.9,2.27-2.9s2.28,1.08,2.28,2.9-1,2.9-2.28,2.9S257.76,315.76,257.76,313.94Zm3.95,0c0-1.52-.68-2.36-1.68-2.36s-1.68.84-1.68,2.36.69,2.36,1.68,2.36S261.71,315.46,261.71,313.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.15,313.94c0-1.82,1-2.9,2.28-2.9s2.28,1.08,2.28,2.9-1,2.9-2.28,2.9S263.15,315.76,263.15,313.94Zm4,0c0-1.52-.68-2.36-1.67-2.36s-1.68.84-1.68,2.36.68,2.36,1.68,2.36S267.1,315.46,267.1,313.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.69,293.24c1.5,23.05-9.18,48.72-9.18,48.72l-57.69-16.24-10.06-2.84c10-13.89,14.76-41.25,12.15-63.39-.2-1.67-.32-3.24-.41-4.74-1-18.26,6.59-23.6,13-31.67,7-8.74,22.58-41.74,22.58-49.55s19.55-26.93,15.2-48.63c0,0,5.91-3.67,11.85-.66,2.7,1.36,5.39,4.09,7.56,9.15,5.09,11.89-2.06,45.5-8.14,53.74l-11.71,48.48s3.95,6.81,7.83,19.17A164.89,164.89,0,0,1,186.69,293.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5,254.75c3.27,8.95,6.74,15,6.44,27.54s-7,31.84-5.09,41.87a8.83,8.83,0,0,0-3,1.56l-10.06-2.84c10-13.89,14.76-41.25,12.15-63.39C121.71,257.82,121.59,256.25,121.5,254.75Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.55,187.13l-11.71,48.48s3.95,6.81,7.83,19.17l0,0C171.74,242,165,238.18,165,238.18c5.28-6.33,9.35-52.63,9.35-52.63s16.55-19.45,15-39.8a65,65,0,0,0-5.22-21.51c2.7,1.36,5.39,4.09,7.56,9.15C196.78,145.28,189.63,178.89,183.55,187.13Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.76,322.88c10-13.89,14.76-41.25,12.16-63.39s5.64-27.68,12.59-36.42,22.57-41.73,22.57-49.55,19.54-26.91,15.2-48.62c0,0,12.47-7.73,19.41,8.49,5.09,11.9-2.06,45.5-8.14,53.75l-11.7,48.47s12.49,21.55,14.84,57.63c1.5,23.05-9.18,48.73-9.18,48.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.32,360.41s13.13,8.08,20.79,20.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,375.7s-11.31,1.61-21.53-10.62c-6.55-7.83-26.44-11.37-31-31.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.58,436.26c-28.95-13.85-11.42-24.95-51.25-42.14s-40.23-31.88-35.43-65.66,1-69.71,12.58-72.76-9.06-49.64,4.44-66.11l66.44,129.24Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.45,434.91c-1.36-3.89-2.74-8.14-3.81-12-1.38-5-2.46-9-5-13.65-.4-.74-.83-1.52-1.31-2.36-2.71-4.83-6.42-11.44-8.59-19.56-1.46-5.47,0-18.94,1.36-32,1-9.38,1.91-18.23,1.64-23.25l-.08-1.78c-.68-13.13-2.1-40.45-5-48-2.85-7.28-5.51-8.37-10.36-10.31-.5-.22-1-.42-1.58-.66-1.82-.76-4.92-2.36-8.49-4.21-8.05-4.17-18.07-9.36-23.16-10a45.36,45.36,0,0,0-14.27.66c-6.27-4.81-16.94-11-20.12-11.13-2.6-.13-8.28,1.5-11,2.35l-1.37.44a41.17,41.17,0,0,0-5.46-3.58c-.13-.07-.26-.12-.37-.17-3.53-1.45-8.86-1.5-11.77-1.42-.88,0-1.57.09-1.88.12-5.49-8.45-10.89-16.86-13.24-20.55-4.9-7.76-20.07-39.69-20.22-40a.27.27,0,0,0-.2-.16.51.51,0,0,0-.14,0c-1.18-.34-9.87-2.55-13.36,5.87-3.82,9.17,1.63,29.3,6.95,36.61,2.56,3.52,9.55,17.88,16.64,32.74-1.82,1.69-16.38,15.14-23.45,17.65-5.79,2.05-4.43,31.73-3.34,55.56.41,8.8.75,16.37.65,20.92-.2,8.8,15.81,20.92,31.33,32.64,14,10.62,28.52,21.59,30.22,29.56.47,2.24,1.81,4.06,3.41,6.11,2.67,3.4,6.11,7.41,7.57,15,.43,2.28,4.09,5.26,7,10.13H461.69C460.81,444.11,459.15,439.79,457.45,434.91ZM311.78,276.81c5.09,10.66,8.24,17,9,17.71s.71,4.09.69,7.38a59.35,59.35,0,0,0,.3,8.63c-1.24,1.09-9.07,8.22-10.65,14l-6.65-7.83-1.68-24.57C303.79,291.07,310.63,283.84,311.78,276.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.31,345.31c2.47,23.05,2.5,35.55,5.27,42.22,4.68,11.26,11.57,13.54,11.57,13.54a69.45,69.45,0,0,1-5.43-13.71c-1.45-5.47,0-18.94,1.36-32,1-9.38,1.92-18.24,1.66-23.26l-.09-1.78c-.68-13.12-2.1-40.44-5-48-2.84-7.28-5.51-8.37-10.36-10.32-.5-.21-1-.41-1.58-.65-1.82-.76-4.91-2.36-8.49-4.21-8.05-4.17-18.07-9.36-23.16-10a45,45,0,0,0-14.27.66c-6.27-4.81-16.94-11-20.12-11.13-2.6-.13-9.65,1.92-12.39,2.79,12,9.79,29.28,22,29.28,22,13.67,2.72,11.92,8.65,17.45,12,5,3,9.78-5.78,14-6.55,5.52-1,11.79,4.82,11.51,11.88C417.66,308.24,425.19,325.52,427.31,345.31Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.21,273.88s-10.83-9-16-12-6-13.34-1.92-15.85a1.14,1.14,0,0,1,.51-.16l-.37-.17c-3.53-1.45-8.86-1.51-11.77-1.42,6,11.17,10.79,19.74,12.08,21.62C345.09,272.18,358.21,273.88,358.21,273.88Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.78,413.84c.46-2.39-3.48-9.39-5.21-12.23-3.93-6.48-49.56-46.8-42.95-57.56s12.65-2.8,16.83-2.1c3,.5,11.24-4.41,11.2-4.82-.94-8.29,6.71-13.68,6.71-13.68s-.7-33-2.46-32.44-22.82-49.55-22.82-49.55-22.26-29.6-21-43.41S293,184,293,184l0-.37c-1.18-.34-9.87-2.55-13.36,5.87-3.82,9.17,1.63,29.3,6.95,36.61,2.56,3.52,9.55,17.88,16.64,32.74-1.82,1.69-16.38,15.14-23.45,17.65-5.79,2.05-4.43,31.73-3.34,55.56.41,8.8.75,16.37.65,20.92-.2,8.8,15.81,20.92,31.33,32.64,14,10.62,28.52,21.59,30.22,29.56.47,2.24,1.81,4.06,3.41,6.11A40.55,40.55,0,0,1,341.78,413.84Zm-30-137c5.09,10.66,8.24,17,9,17.71s.71,4.09.69,7.38a59.35,59.35,0,0,0,.3,8.63c-1.24,1.09-9.07,8.22-10.65,14l-6.65-7.83-1.68-24.57C303.79,291.07,310.63,283.84,311.78,276.81Z",
    style: {
      fill: "#FAA700",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,273.75a22.74,22.74,0,0,1-11.24-7.88c-4.57-6.12-22.52-34-27.49-41.86S293,184,293,184s-9.4-3.15-13.06,5.63,1.35,28.62,6.92,36.26S318.9,292.36,321,294.26s-1.05,17.6,3.16,21.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.14,310.67s-9.7,8.45-10.84,14.62l-7.2-8.47L302.4,292s8.69-8.7,9.17-16.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.63,258.88s-16.11,15.2-23.77,17.91-2.07,59.66-2.45,76.15,57.95,45.22,61.53,62.1c1.42,6.72,7.3,8.09,10.89,21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.56,244.73s8.77-.79,13.71,1.27,25,19.29,29.84,22.58,12.12,4.54,13.5,8.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.17,249.81s9-3,12.44-2.83,16.38,7.8,22.18,12.9a49.44,49.44,0,0,0,15.11,9.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.68,258.15a43.89,43.89,0,0,1,14.3-.69c7.32,1,25.7,11.8,31.56,14.24s8.66,2.89,11.74,10.77,4.49,37.84,5.11,49.68-5.55,45.75-3,55.29,7.15,16.9,9.94,22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.4,292S301,286.15,299,285.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.1,316.82a74.52,74.52,0,0,0,2.73,10.05c1.44,3.55-.8,8.69-.8,8.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.3,325.29c-.23,5.68,5.42,12.32,6.79,11.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.07,292s6.07-9.82,11.89-10.3,12.54,7.78,16.13,7,8.11-6.06,14.15-7,8.87,1.94,13.66,2.18,5.28-6.16,11-7,7.67,2,11.51,2.74,4.8-2.29,7.91-4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.a896f9002b6c632dd492a821c80a5448.svg";
export { ForwardRef as ReactComponent };